module.exports = __webpack_public_path__ + "static/media/skid-steer-loaders.1e360c04.jpg";